var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8107 9.11975L22.0007 9.73975L16.5507 14.4698L18.1807 21.4998L12.0007 17.7698L5.82075 21.4998L7.46075 14.4698L2.00075 9.73975L9.19075 9.12976L12.0007 2.49976L14.8107 9.11975ZM8.23974 18.17L11.9997 15.9L15.7697 18.18L14.7697 13.9L18.0897 11.02L13.7097 10.64L11.9997 6.60001L10.2997 10.63L5.91974 11.01L9.23974 13.89L8.23974 18.17Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteMobileIcon);
export default __webpack_public_path__ + "static/media/favorite-mobile-icon.1326dc2527a2c7e38d0b7276e6ece5da.svg";
export { ForwardRef as ReactComponent };